var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('documentType')}`,"value-key":"key"},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(option){return _c('el-option',{key:option.key,attrs:{"label":`(${option.key}) ${option.value}`,"value":option.key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }